import { render, staticRenderFns } from "./SlideshowNavBottom.vue?vue&type=template&id=c1bcd206&scoped=true&"
import script from "./SlideshowNavBottom.vue?vue&type=script&lang=js&"
export * from "./SlideshowNavBottom.vue?vue&type=script&lang=js&"
import style0 from "./SlideshowNavBottom.vue?vue&type=style&index=0&id=c1bcd206&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1bcd206",
  null
  
)

export default component.exports